/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Butmassnahmeneinstellenbis5Inputs */

const de__field_butmassnahmeneinstellenbis5 = /** @type {(inputs: _Field_Butmassnahmeneinstellenbis5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BuT-Maßnahmen einstellen bis`)
};

/**

* @param {_Field_Butmassnahmeneinstellenbis5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_butmassnahmeneinstellenbis5 = /** @type {((inputs?: _Field_Butmassnahmeneinstellenbis5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Butmassnahmeneinstellenbis5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_butmassnahmeneinstellenbis5(inputs)
});
export { _field_butmassnahmeneinstellenbis5 as "_field_BuTMassnahmenEinstellenBis" }